"use strict";

exports.__esModule = true;
exports.ParamsPaddingButton = void 0;

var _react = _interopRequireWildcard(require("react"));

var _react2 = require("@chakra-ui/react");

var _io = require("react-icons/io5");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react["default"].createElement;

/**
 * @typedef {object} Props
 * @property {number} paddingTop
 * @property {number} paddingRight
 * @property {number} paddingBottom
 * @property {number} paddingLeft
 * @property {boolean} useCustomPaddings
 * @property {Function} onUpdate
 */

/**
 * @param {Props} props
 */
var ParamsPaddingButton = function ParamsPaddingButton(_ref) {
  var paddingTop = _ref.paddingTop,
      paddingRight = _ref.paddingRight,
      paddingBottom = _ref.paddingBottom,
      paddingLeft = _ref.paddingLeft,
      useCustomPaddings = _ref.useCustomPaddings,
      onUpdate = _ref.onUpdate;

  var _useState = (0, _react.useState)(paddingLeft === paddingRight),
      lockPaddingHorizontal = _useState[0],
      setLockPaddingHorizontal = _useState[1];

  var _useState2 = (0, _react.useState)(paddingTop === paddingBottom),
      lockPaddingVertical = _useState2[0],
      setLockPaddingVertical = _useState2[1];

  var _onChange = function onChange(changes) {
    Object.keys(changes).forEach(function (key) {
      if (isNaN(changes[key])) {
        changes[key] = 0;
      }

      changes[key] = Math.min(changes[key], 500);
    });
    onUpdate(changes);
  };

  return __jsx(_react2.Stack, {
    spacing: "8px"
  }, __jsx(_react2.Checkbox, {
    isChecked: useCustomPaddings,
    onChange: function onChange() {
      _onChange({
        useCustomPaddings: !useCustomPaddings
      });
    }
  }, "Utiliser des marges personnalis\xE9es"), __jsx(_react2.HStack, {
    alignItems: "flex-end",
    spacing: "4"
  }, __jsx(_react2.FormControl, {
    isDisabled: !useCustomPaddings,
    w: "auto"
  }, __jsx(_react2.FormLabel, {
    fontWeight: "normal"
  }, "Haut"), __jsx(_react2.NumberInput, {
    value: paddingTop,
    onChange: function onChange(valueStr, value) {
      if (lockPaddingVertical) {
        _onChange({
          paddingTop: value,
          paddingBottom: value
        });
      } else {
        _onChange({
          paddingTop: value
        });
      }
    },
    min: 0,
    max: 500,
    maxW: "100px",
    variant: "filled"
  }, __jsx(_react2.NumberInputField, null), __jsx(_react2.NumberInputStepper, null, __jsx(_react2.NumberIncrementStepper, null), __jsx(_react2.NumberDecrementStepper, null)))), __jsx(_react2.IconButton, {
    onClick: function onClick() {
      return setLockPaddingVertical(!lockPaddingVertical);
    },
    isDisabled: !useCustomPaddings,
    "aria-label": "Toggle lock",
    color: lockPaddingVertical ? "#EAA82F" : "#ccc",
    icon: __jsx(_react2.Icon, {
      as: lockPaddingVertical ? _io.IoLockClosedOutline : _io.IoLockOpenOutline
    })
  }), __jsx(_react2.FormControl, {
    isDisabled: !useCustomPaddings,
    w: "auto"
  }, __jsx(_react2.FormLabel, {
    fontWeight: "normal"
  }, "Bas"), __jsx(_react2.NumberInput, {
    value: paddingBottom,
    onChange: function onChange(valueStr, value) {
      if (lockPaddingVertical) {
        _onChange({
          paddingBottom: value,
          paddingTop: value
        });
      } else {
        _onChange({
          paddingBottom: value
        });
      }
    },
    min: 0,
    max: 500,
    maxW: "100px",
    variant: "filled"
  }, __jsx(_react2.NumberInputField, null), __jsx(_react2.NumberInputStepper, null, __jsx(_react2.NumberIncrementStepper, null), __jsx(_react2.NumberDecrementStepper, null))))), __jsx(_react2.HStack, {
    alignItems: "flex-end",
    spacing: "4"
  }, __jsx(_react2.FormControl, {
    isDisabled: !useCustomPaddings,
    w: "auto"
  }, __jsx(_react2.FormLabel, {
    fontWeight: "normal"
  }, "Gauche"), __jsx(_react2.NumberInput, {
    value: paddingLeft,
    onChange: function onChange(valueStr, value) {
      if (lockPaddingHorizontal) {
        _onChange({
          paddingLeft: value,
          paddingRight: value
        });
      } else {
        _onChange({
          paddingLeft: value
        });
      }
    },
    min: 0,
    max: 500,
    maxW: "100px",
    variant: "filled"
  }, __jsx(_react2.NumberInputField, null), __jsx(_react2.NumberInputStepper, null, __jsx(_react2.NumberIncrementStepper, null), __jsx(_react2.NumberDecrementStepper, null)))), __jsx(_react2.IconButton, {
    onClick: function onClick() {
      return setLockPaddingHorizontal(!lockPaddingHorizontal);
    },
    isDisabled: !useCustomPaddings,
    "aria-label": "Toggle lock",
    color: lockPaddingHorizontal ? "#EAA82F" : "#ccc",
    icon: __jsx(_react2.Icon, {
      as: lockPaddingHorizontal ? _io.IoLockClosedOutline : _io.IoLockOpenOutline
    })
  }), __jsx(_react2.FormControl, {
    isDisabled: !useCustomPaddings,
    w: "auto"
  }, __jsx(_react2.FormLabel, {
    fontWeight: "normal"
  }, "Droite"), __jsx(_react2.NumberInput, {
    value: paddingRight,
    onChange: function onChange(valueStr, value) {
      if (lockPaddingHorizontal) {
        _onChange({
          paddingRight: value,
          paddingLeft: value
        });
      } else {
        _onChange({
          paddingRight: value
        });
      }
    },
    min: 0,
    max: 500,
    maxW: "100px",
    variant: "filled"
  }, __jsx(_react2.NumberInputField, null), __jsx(_react2.NumberInputStepper, null, __jsx(_react2.NumberIncrementStepper, null), __jsx(_react2.NumberDecrementStepper, null))))));
};

exports.ParamsPaddingButton = ParamsPaddingButton;